import { vars } from 'src/core/themes';

import { PosIconProps, SvgWrapper } from '../SvgWrapper';

export const AllZonesIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper
      {...props}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.6002 18.4C33.6002 12.6563 28.944 8.00005 23.2002 8.00005H16.8002C11.0564 8.00005 6.4002 12.6563 6.4002 18.4V21.6C6.4002 27.3438 11.0564 32 16.8002 32H23.2002C28.944 32 33.6002 27.3438 33.6002 21.6V18.4ZM36.8002 21.6C36.8002 29.1111 30.7113 35.2 23.2002 35.2H16.8002C9.28912 35.2 3.2002 29.1111 3.2002 21.6V18.4C3.2002 10.889 9.28912 4.80005 16.8002 4.80005H23.2002C30.7113 4.80005 36.8002 10.889 36.8002 18.4V21.6Z"
        fill={vars.color.textPrimaryV2}
      />
      <path
        d="M28.8002 18.4C28.8002 15.3073 26.293 12.8 23.2002 12.8H16.8002C13.7074 12.8 11.2002 15.3073 11.2002 18.4V21.6C11.2002 24.6928 13.7074 27.2 16.8002 27.2H23.2002C26.293 27.2 28.8002 24.6928 28.8002 21.6V18.4ZM32.0002 21.6C32.0002 26.4602 28.0603 30.4 23.2002 30.4H16.8002C11.9401 30.4 8.0002 26.4602 8.0002 21.6V18.4C8.0002 13.5399 11.9401 9.60005 16.8002 9.60005H23.2002C28.0603 9.60005 32.0002 13.5399 32.0002 18.4V21.6Z"
        fill={vars.color.textPrimaryV2}
      />
      <path
        d="M24.0002 18.4C24.0002 17.9582 23.642 17.6 23.2002 17.6H16.8002C16.3584 17.6 16.0002 17.9582 16.0002 18.4V21.6C16.0002 22.0419 16.3584 22.4 16.8002 22.4H23.2002C23.642 22.4 24.0002 22.0419 24.0002 21.6V18.4ZM27.2002 21.6C27.2002 23.8092 25.4093 25.6 23.2002 25.6H16.8002C14.5911 25.6 12.8002 23.8092 12.8002 21.6V18.4C12.8002 16.1909 14.5911 14.4 16.8002 14.4H23.2002C25.4093 14.4 27.2002 16.1909 27.2002 18.4V21.6Z"
        fill={vars.color.textPrimaryV2}
      />
    </SvgWrapper>
  );
};
